import React, { useEffect, useMemo } from 'react';
import Botao from '../../components/Botao';
import Icon from '@mdi/react';
import { mdiCloseCircle } from '@mdi/js';

type ArquivoAnexoProps = {
    arquivo: File
    onRemove: () => void
}

const formatarTamanho = (bytes: number) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const ArquivoAnexo = ({ arquivo, onRemove }: ArquivoAnexoProps) => {
    const ehImagem = arquivo.type.indexOf('image/') === 0;

    // Uma URL por arquivo, revogada ao sair. Antes era criada a cada render e
    // nunca liberada: o browser só devolvia a memória ao descarregar a página.
    const fileURL = useMemo(
        () => (ehImagem ? URL.createObjectURL(arquivo) : null),
        [arquivo, ehImagem],
    );

    useEffect(() => {
        if (!fileURL) return;
        return () => URL.revokeObjectURL(fileURL);
    }, [fileURL]);

    return (
        <div style={{ margin: '.5rem', width: '96px' }}>
            <div style={{ display: 'flex' }}>
                <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={arquivo.name}>{arquivo.name}</span>
                <Botao variant="none-secondary" onClick={onRemove} title="Remover anexo">
                    <Icon path={mdiCloseCircle} size="1rem" />
                </Botao>
            </div>
            <div style={{ fontSize: '.75rem', fontStyle: 'italic', color: '#888', textAlign: 'center' }}>({arquivo.type || 'desconhecido'})</div>
            <div style={{ textAlign: 'center', minHeight: '42px' }}>
                {fileURL ? <img src={fileURL} style={{ maxHeight: '42px', maxWidth: '96px' }} alt={arquivo.name} /> : null}
            </div>
            <div style={{ fontSize: '.75rem', color: '#888', textAlign: 'center' }}>{formatarTamanho(arquivo.size)}</div>
        </div>
    )
}

export default ArquivoAnexo;
